import React, { useEffect } from 'react';
import Range from '@framework/ui/Organisms/Filters/FiltersPanel/Range/Range';
import {
  CURRENT_FACE_RANGE_PRESET,
  CURRENT_FACE_RANGE_PRESET_FILTER_NAME,
} from '@/creditflowresearch/ui/components/bonds/common/BondsSidebar/constants';
import FilterItem from '@/creditflowresearch/ui/common/components/FilterItem';
import CheckboxField from '@framework/ui/Organisms/Filters/Checkboxer/CheckboxFieldContainer';
import Checkbox from '@creditflowresearch/uilib/Checkbox';
import FilterColumns from '@framework/ui/Organisms/Filters/components/FilterColumns';

interface IProps {
  isRangeDisabled: boolean,
  sectionId: string,
  filterName: string,
  minValue: number,
  maxValue: number,
  columnsCount: number,
  handleFilterByChange: (name: string, ids: string[]) => void,
  handleFilterUpdate: (filter: { [k: string]: any }) => void,
  isFilterChecked: (name: string, id: string) => boolean,
  inputValueFormatter: (...args: any) => any,
  selectedRangeValue?: any,
  filters?: any,
}

const CurrentFaceRangeWithList = (props: IProps) => {
  useEffect(() => {
    if (props.isRangeDisabled) {
      props.handleFilterUpdate({
        [props.filterName]: {
          range: {
            min: props.minValue,
            max: props.maxValue,
          },
          minValue: props.minValue,
          maxValue: props.maxValue,
        },
      });
    }
  }, [props.isRangeDisabled]);

  return (
    <Range disabled={ props.isRangeDisabled } { ...props }>
      <FilterColumns columnsCount={ props.columnsCount }>
        { CURRENT_FACE_RANGE_PRESET.map(({
          currentFaceRangeId: id,
          currentFaceRangeName: label,
          currentFaceRangeFromValue,
          currentFaceRangeToValue,
        }) => (
          <FilterItem key={ id }>
            <CheckboxField
              parent={ props.sectionId }
              dataTest={ `currentFaceRange ${ label } checkbox` }
              name={ id }
              component={ Checkbox }
              label={ label }
              disabled={ (
                (currentFaceRangeToValue && Number(currentFaceRangeToValue) < props.minValue) ||
                (Number(currentFaceRangeFromValue) > props.maxValue)
              ) }
              defaultChecked={ props.isFilterChecked(CURRENT_FACE_RANGE_PRESET_FILTER_NAME, id) }
              onChange={ () => props.handleFilterByChange(CURRENT_FACE_RANGE_PRESET_FILTER_NAME, [id]) }
            />
          </FilterItem>
        )) }
      </FilterColumns>
    </Range>
  );
};

export default CurrentFaceRangeWithList;
